import React from 'react';
import styles from '../ScheduleTabs.module.scss';

function Tab(props) {
    const { className = '', selected = false, disabled = false, children, onClick } = props;

    return (
        <button type="button" className={[className, selected ? styles.selected : ''].join(' ')} disabled={disabled} onClick={onClick}>
            {children}
        </button>
    );
}

export default Tab;
